module.exports = __webpack_public_path__ + "img/imgduihjl-wxz.4dee1267.png";